import React from "react";
export default function PdfComponent({ url, downloadName = "document.pdf" }) {
  return (
    <div style={{ display: "grid", gap: 12 }}>
      <iframe title="PDF Preview" src={url} style={{ width: "100%", height: "80vh", border: "1px solid #ddd", borderRadius: 8 }} />
      <a href={url} download={downloadName}>
        <button style={{ padding: "8px 12px" }}>Download PDF</button>
      </a>
    </div>
  );
}